import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import * as moment from 'moment';
import { HospitalListComponent } from 'src/app/components/hospital-list/hospital-list.component';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { EventsService } from 'src/app/providers/events/events.service';
import { SortPipe } from 'src/app/pipes/sort.pipe';
import { AccessService } from 'src/app/providers/access/access.service';
@Component({
  selector: 'app-ward-round',
  templateUrl: './ward-round.page.html',
  styleUrls: ['./ward-round.page.scss'],
  providers: [SortPipe]
})
export class WardRoundPage {
  user: any;
  patientlist: any[] = [];
  filteredPatientList: any[] = [];
  inboxMessages: any = [];
  unreadCount: any = 0;
  page: number;
  perPage: number;
  hasMore: boolean;
  hasSkelton: boolean;
  nodata: boolean;
  filter: string;
  currentSortProperty: string = 'patient_last_name';
  isAscendingSort: boolean = false;
  constructor(
    private apiService: ApiService,
    public router: Router,
    public navCtrl: NavController,
    public modalController: ModalController,
    public toastService: ToastService,
    public storageService: StorageService, 
    private eventsService: EventsService,
    private sortPipe: SortPipe,
    public accessService: AccessService,
    ) {
  }

  ionViewWillEnter() {
    this.page = 1;
    this.perPage = 10;
    this.hasMore = true;
    this.fetchWardUsers('');
    //this.sortPatients('patient_last_name');
  }

  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }

  sortPatients(property: string) {

    if (this.currentSortProperty === property) {
      // Toggle between ascending and descending order
      this.isAscendingSort = !this.isAscendingSort;
    } else {
      // Set ascending order by default when changing the sorting property
      this.isAscendingSort = true;
      this.currentSortProperty = property;
    }

    /* const sortOrder = this.isAscendingSort ? 'asc' : 'desc';
    this.filteredPatientList = this.sortPipe.transform(
      this.filteredPatientList,
      `${property}`,
      sortOrder
    ); */

    this.fetchWardUsers('');
  }

  getSortIcon(property: string): string {
    if (this.currentSortProperty === property) {
      return this.isAscendingSort ? 'caret-up-circle' : 'caret-down-circle';
    }
    return ''; // Default icon when not sorting by this property
  }

  fetchWardUsers(filter) {
    this.filteredPatientList = [];
    this.hasSkelton = true;
    const params = {
      page: this.page,
      perPage: this.perPage,
      sort: this.currentSortProperty,
      asc: this.isAscendingSort?'true':'false',
      filter
    };
    this.apiService.post('data/ward-listing', params).subscribe(
      (res) => {
        //console.log(res);
        this.hasSkelton = false;
        if (res.error === false) {
          this.patientlist = res.data.submissions;
          // this.patientlist.map(
          //   (element) => {
          //     element.Data.updated_at = moment(element.Data.updated_at).format(
          //       'DD/MM/YYYY');
          //   });
          this.filteredPatientList = this.patientlist;
          if (this.patientlist.length < this.perPage) {
            this.hasMore = false;
          } else {
            this.page++;
          }
        }
      },
      (err) => {
        this.hasSkelton = false;
      }
    );
  }

  doInfinite(infiniteScroll) {
    this.hasSkelton = true;
    if (this.hasMore) {
      const params = {
        page: this.page,
        perPage: this.perPage
      };
      this.apiService.post('data/ward-listing', params).subscribe(
        (res) => {
          this.hasSkelton = false;
          if (res.error === false) {
            res.data.submissions.map(
              (element) => {
                // element.Data.updated_at = moment(element.Data.updated_at).format(
                //   'DD/MM/YYYY');
                this.patientlist.push(element);
                this.filteredPatientList = this.patientlist;
              });
            if (res.data.submissions.length < this.perPage) {
              this.hasMore = false;
            } else {
              this.page++;
            }
            infiniteScroll.target.complete();
          }
        },
        async (err) => {
          this.hasSkelton = false;
          infiniteScroll.target.complete();
        }
      );
    } else {
      this.hasSkelton = false;
      infiniteScroll.target.complete();
      infiniteScroll.target.disabled = true;
    }
  }

  patientInfo(data) {
    this.storageService.set('state', 'ward');
    const navigationExtras: NavigationExtras = {
      state: data
    };
    this.navCtrl.navigateForward('patientInfo', navigationExtras).then(() => this.eventsService.publish('PatientInfoEvent', data));
  }

  searchPatients(event: any): void {
    if (!event) {
      this.filteredPatientList = this.patientlist;
    }
    const newValue = event.target.value && event.target.value.trim().toLowerCase();
    if (!newValue || !this.patientlist) {
      this.filteredPatientList = this.patientlist;
    } else if (this.patientlist.length > 0 && typeof this.patientlist[0].Data.patient_first_name != 'undefined') {
      this.filteredPatientList = this.patientlist.filter((doctor) =>
        doctor.Data?.patient_first_name.toLowerCase().indexOf(newValue) > -1 || doctor.Data?.patient_last_name.toLowerCase().indexOf(newValue) > -1);
    }
  }


  async listDataFilter() {
    const modal = await this.modalController.create({
      component: HospitalListComponent,
      cssClass: 'selectHospitalModal',
      showBackdrop: true,
      backdropDismiss: true
    });
    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.page = 1;
      this.fetchWardUsers(data.hospital);
    }
  }

  goToAdvance() {
    this.storageService.set('state', 'ward-round');
    this.navCtrl.navigateForward('advanced');
  }
}
